<div
    *ngIf="virtualSession"
    class="session container"
    xmlns="http://www.w3.org/1999/html"
>
    <h1>
        <i class="fa fa-bookmark-o fa-pre" aria-hidden="true"></i>
        {{ virtualSession.title }}
    </h1>

    <div class="resume" style="position: absolute;right: 70px;top: 110px;">
        <div class="infos">
            <div class="icon-set date">
                <i class="fa fa-calendar" aria-hidden="true"></i>
                <span>{{
                    'training-detail.training.virtual-session.creationDate'
                        | translate
                }}</span>
                <span class="info-resume">{{
                    virtualSession.creationDate | formatdatepipe
                }}</span>
            </div>
        </div>
    </div>

    <div>
        <ul class="nav nav-tabs nav-justified" role="tablist">
            <li role="presentation" class="active session-detail-tab">
                <a
                    href="#description"
                    aria-controls="description"
                    role="tab"
                    data-toggle="tab"
                >
                    <h3>{{ 'session-details.description' | translate }}</h3>
                </a>
            </li>
            <li role="presentation" class="session-detail-tab">
                <a
                    href="#search-trainer-module"
                    aria-controls="search-trainer-module"
                    role="tab"
                    data-toggle="tab"
                >
                    <h3>{{ 'session-details.trainerSearch' | translate }}</h3>
                </a>
            </li>
            <li role="presentation" class="session-detail-tab">
                <a
                    href="#answers-module"
                    aria-controls="answers-module"
                    role="tab"
                    data-toggle="tab"
                >
                    <h3>{{ 'session-details.trainerAnswers' | translate }}</h3>
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <!-- DESCRIPTION TAB -->
            <div
                role="tabpanel"
                class="tab-pane active formateurs"
                id="description"
            >
                <form
                    name="form"
                    role="form"
                    (ngSubmit)="save()"
                    #virtualSessionForm="ngForm"
                    novalidate
                    show-validation
                    class="form-horizontal"
                >
                    <div class="form-group">
                        <label class="control-label col-sm-2" for="title">
                            {{
                                'training-detail.training.virtual-session.title'
                                    | translate
                            }}
                        </label>
                        <div class="col-sm-4">
                            <input
                                type="text"
                                class="form-control "
                                id="title"
                                name="title"
                                placeholder="{{
                                    'training-detail.training.virtual-session.form.title.placeholder'
                                        | translate
                                }}"
                                #titleInput="ngModel"
                                [(ngModel)]="virtualSession.title"
                                minlength="1"
                                maxlength="50"
                                required
                            />
                        </div>
                        <div class="control-error col-sm-4">
                            <div *ngIf="titleInput.dirty && titleInput.invalid">
                                <small
                                    class="form-text text-danger"
                                    *ngIf="titleInput.errors.required"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.title.required'
                                            | translate
                                    }}
                                </small>
                                <small
                                    class="form-text text-danger"
                                    *ngIf="titleInput.errors.minlength"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.title.minlength'
                                            | translate
                                    }}
                                </small>
                                <small
                                    class="form-text text-danger"
                                    *ngIf="titleInput.errors.maxlength"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.title.maxlength'
                                            | translate
                                    }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label
                            class="control-label col-sm-2"
                            for="estimationDate"
                        >
                            {{
                                'training-detail.training.virtual-session.estimationDate'
                                    | translate
                            }}
                        </label>
                        <div class="col-sm-4">
                            <input
                                type="text"
                                class="form-control"
                                id="estimationDate"
                                name="estimationDate"
                                placeholder="{{
                                    'training-detail.training.virtual-session.form.estimation-date.placeholder'
                                        | translate
                                }}"
                                [(ngModel)]="virtualSession.estimationDate"
                                minlength="1"
                                maxlength="50"
                                #estimationDateInput="ngModel"
                                required
                            />
                        </div>
                        <div class="control-error col-sm-4">
                            <div
                                *ngIf="
                                    estimationDateInput.dirty &&
                                    estimationDateInput.invalid
                                "
                            >
                                <small
                                    class="form-text text-danger"
                                    *ngIf="estimationDateInput.errors.required"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.estimation-date.required'
                                            | translate
                                    }}
                                </small>
                                <small
                                    class="form-text text-danger"
                                    *ngIf="estimationDateInput.errors.minlength"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.estimation-date.minlength'
                                            | translate
                                    }}
                                </small>
                                <small
                                    class="form-text text-danger"
                                    *ngIf="estimationDateInput.errors.maxlength"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.estimation-date.maxlength'
                                            | translate
                                    }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label col-sm-2" for="message">
                            {{
                                'training-detail.training.virtual-session.message'
                                    | translate
                            }}
                        </label>
                        <div class="col-sm-4">
                            <input
                                type="text"
                                class="form-control"
                                id="message"
                                name="message"
                                placeholder="{{
                                    'training-detail.training.virtual-session.form.message.placeholder'
                                        | translate
                                }}"
                                [(ngModel)]="virtualSession.message"
                                minlength="1"
                                #messageInput="ngModel"
                                required
                            />
                        </div>
                        <div class="control-error col-sm-4">
                            <div
                                *ngIf="
                                    messageInput.dirty && messageInput.invalid
                                "
                            >
                                <small
                                    class="form-text text-danger"
                                    *ngIf="messageInput.errors.required"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.message.required'
                                            | translate
                                    }}
                                </small>
                                <small
                                    class="form-text text-danger"
                                    *ngIf="messageInput.errors.minlength"
                                >
                                    {{
                                        'training-detail.training.virtual-session.messages.validate.message.minlength'
                                            | translate
                                    }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label
                            class="control-label col-sm-2"
                            for="archived"
                            jhiTranslate="training-detail.training.virtual-session.archived"
                            >Archived</label
                        >
                        <div class="col-sm-4">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                id="archived"
                                name="archived"
                                [(ngModel)]="virtualSession.archived"
                            />
                        </div>
                    </div>
                    <div class="form-group form-validation">
                        <div class="col-sm-4 col-sm-offset-2">
                            <button
                                type="submit"
                                class="btn btn-primary"
                                [disabled]="virtualSessionForm.form.invalid"
                                jhiTranslate="training-detail.training.virtual-session.save"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- SEARCH TRAINER TAB -->
            <div
                role="tabpanel"
                class="tab-pane formateurs search-formateur"
                id="search-trainer-module"
            >
                <staffing-search
                    [session]="virtualSession"
                    [trainers]="trainers"
                    [responses]="trainersResponses"
                    [selectedTrainers]="selectedTrainers"
                    [sendMailFunction]="sendMail()"
                >
                </staffing-search>
            </div>

            <!-- RESULT SEARCH TRAINER TAB -->
            <div
                role="tabpanel"
                class="tab-pane formateurs"
                id="answers-module"
            >
                <staffing-results
                    [session]="virtualSession"
                    [trainers]="selectedTrainers"
                    [responses]="trainersResponses"
                    [sendMailFunction]="sendMail()"
                >
                </staffing-results>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing/detail/detail.component.html